// Ensure this matches values set in snippet.product-data.liquid
const COLOR_OPTION_NAMES = ["Color", "School", "Your School"];

export function isColor(value) {
  return COLOR_OPTION_NAMES.includes(value);
}

export function findColorOptionName(options) {
  if (!options) return COLOR_OPTION_NAMES[0];

  const colorOption = options.find(option => isColor(option.name));

  return colorOption ? colorOption.name : COLOR_OPTION_NAMES[0];
}
